var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('span',{class:_vm.classObject},[_vm._v(" "+_vm._s(_vm.title)+" "+_vm._s(_vm.description)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }